<template>
  <div class="tip-float-card" @click="handledClick" :style="cardStyle">
    <div class="float-bg"></div>
    <!-- <div class="card-title">立即注册</div>
    <div>申请免费权限，查看更多商品资讯</div> -->
  </div>
</template>

<script>
export default {
  name: "TipCard",

  data() {
    return {
      cardStyle: {},
    };
  },
  mounted() {
    this.cardAnimation();
  },
  methods: {
    handledClick() {
      this.$emit("click");
    },
    cardAnimation() {
      setTimeout(() => {
        this.cardStyle = {
          right: "3vw",
        };
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss" >
.tip-float-card {
  position: fixed;
  z-index: 6;
  bottom: 60px;
  // right: 20px;
  // right: -264px;
  // width: 264px;
  width: 166px;
  right: -166px;
  // background-color: #2b304d;
  color: #ffffff;
  padding: 10px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  transition: all 500ms ease-in-out;
  --tw-shadow: 0 4rpx 12rpx 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

  .float-bg {
    width: 166px;
    height: 183px;
    background-image: url(../assets/home/float-card.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .card-title {
    font-size: 20px;
    line-height: 30px;
  }
}
</style>